import { useState } from 'react';
import { useEffect } from 'react';
import { Modal, Form, Row, Col } from 'react-bootstrap';
import { upsertMasterDataCurrency } from '../../apiCalls';
import { Input } from '../../Input/Input';

const CurrencyModal = ({ onSave, onCancel, currency, onError }) => {
  const [localCurrency, setLocalCurrency] = useState({});

  useEffect(() => {
    setLocalCurrency(currency);
  }, [currency]);

  async function submitForm(event) {
    event.preventDefault();
    try {
      const isNew = localCurrency.id === -1;
      const payload = {
        id: isNew ? null : localCurrency.id,
        code: localCurrency.code,
        description: localCurrency.description,
        softDelete: 0,
      };

      await upsertMasterDataCurrency(payload);
      onSave(isNew);
      onCancel();
    } catch (err) {
      console.log(err);
      if (onError) onError(err.message || 'Failed to save currency');
    }
  }

  const isNew = localCurrency?.id === -1;

  return (
    <Modal
      show={localCurrency?.id !== undefined}
      onHide={onCancel}
      centered
      size="lg"
      contentClassName="editModal"
      dialogClassName="wide-modal"
    >
      <Modal.Header>
        <Modal.Title>{isNew ? 'Add Currency' : `Edit: ${localCurrency?.description || ''}`}</Modal.Title>{' '}
        <button type="button" class="btn-close" aria-label="Close" onClick={onCancel} />
      </Modal.Header>
      <Form onSubmit={submitForm} className="flex-grow-1 d-flex flex-column">
        <Modal.Body className="flex-grow-1">
          <Row>
            <Col>
              <Input
                name="code"
                type="text"
                label="Currency Code"
                required
                value={localCurrency?.code || ''}
                onChange={(e) => setLocalCurrency((prev) => ({ ...prev, code: e.target.value }))}
                maxLength="6"
              />
            </Col>
            <Col>
              <Input
                name="description"
                type="text"
                label="Description"
                required
                value={localCurrency?.description || ''}
                onChange={(e) => setLocalCurrency((prev) => ({ ...prev, description: e.target.value }))}
              />
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer
          class="d-flex flex-row py-3 px-3 gap-3 border-top bg-light justify-content-end align-items-center"
          style={{ borderBottomLeftRadius: '20px', borderBottomRightRadius: '20px' }}
        >
          <button
            type="button"
            class="cancel-button"
            onClick={onCancel}
            style={{ display: 'flex', borderRadius: '10px' }}
          >
            Cancel
          </button>
          <button type="submit" class="blue-button-teams green-btn" style={{ borderRadius: '10px' }}>
            {isNew ? 'Add' : 'Save'}
          </button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};
export default CurrencyModal;
